import React, { PureComponent } from "react";
import Flow from "../services/flow.service";
import { Redirect } from "react-router-dom";

export default class HomeRouter extends PureComponent {
	render() {
		let route = Flow.getRecommendedRoute("HomeRouter");
		if(!Flow.isRouteAFullURL(route)){
			return <Redirect from="/" to={route} />
		}
		return "";
	}
}
